module.exports = __webpack_public_path__ + "static/media/text_size.eff39529.svg";